export default {
    setProducts: (state, products) => { state.products = products },
    setMetadata: (state, metadata) => { state.metadata = metadata },
    setPurchasesModel: (state, purchasesModel) => { state.purchasesModel = purchasesModel },
    setRcConfig: (state, rcConfig) => { state.rcConfig = rcConfig },
    setRecentPurchase: (state, recentPurchase) => { state.recentPurchase = recentPurchase },
    setOpenPurchasesFromMenu: (state, openPurchasesFromMenu) => { state.openPurchasesFromMenu = openPurchasesFromMenu }
}